<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn> </template>
			<HoldingPointSearchSection
				:query="q"
				@search="searchHoldingPoints($event)"
				:firstVisit="firstVisit"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="holding_points"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openDialog(item.order_individual_info.id, item)">
							<td>{{ item.status_i18n }}</td>
							<td>{{ common.productNumberByOrderIndividualInfo(item.order_individual_info) }}</td>
							<td>
								{{
									item.order_individual_info.ordered_product
										? common.productNameWithSubName(item.order_individual_info.ordered_product)
										: ""
								}}
							</td>
							<td>{{ item.order_individual_info.quantity }}</td>
							<td>
								{{ item.check_process.check_process_type.name }}
								（
								<span
									v-for="(checkItem, i) in item.check_process.check_process_type.check_items"
									:key="checkItem.id"
								>
									{{ checkItem.name }}
									<template
										v-if="i != item.check_process.check_process_type.check_items.length - 1"
									>
										,　
									</template>
								</span>
								）
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<HoldingPointShowDialog
			:id="selectedInfoId"
			:holdingPoint="holding_point"
			:dialog.sync="holdingPointShowDialog"
			:authority_flag="authority_flag"
			@update="updateHoldingPoint($event)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import HoldingPointSearchSection from "./components/HoldingPointSearchSection.vue"
import HoldingPointShowDialog from "./components/HoldingPointShowDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		HoldingPointSearchSection,
		HoldingPointShowDialog,
	},
	data() {
		return {
			title: "ホールディングポイント一覧",
			holding_points: [],
			selectedInfoId: null,
			holdingPointShowDialog: false,
			authority_flag: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				order_individual_info_ordered_product_product_number_cont: null,
				check_process_user_id_eq: null,
				order_individual_info_status_in: [
					"order_received",
					"manufacture_started",
					"manufacture_completed",
				],
			},
			common,
			holding_point: {},
			firstVisit: false,
			is_exist_query: false,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.is_exist_query = this.common.isEmptyObject(this.$route.query)
		this.setQuery()
		this.fetchHoldingPoints(this.q, page, true, this.is_exist_query)
	},
	methods: {
		fetchHoldingPoints(q, page, first_visit = false, is_exist_query) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit, is_exist_query }
			axios
				.get("/erp/v1/holding_points", {
					params,
					headers,
				})
				.then((res) => {
					this.holding_points = res.data.holding_points
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.authority_flag = res.data.authority_flag
						this.firstVisit = first_visit
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDialog(order_individual_info_id, holding_point) {
			this.selectedInfoId = order_individual_info_id
			this.holding_point = holding_point
			this.holdingPointShowDialog = true
		},
		getPage(page) {
			this.fetchHoldingPoints(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchHoldingPoints(q) {
			this.q = q
			this.fetchHoldingPoints(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		updateHoldingPoint(holding_point) {
			const index = this.holding_points.findIndex((item) => item.id === holding_point.id)
			if (index > 0) {
				this.holding_points.splice(index, 1, holding_point)
			}
		},
	},
}

function headers() {
	return [
		{ text: "状態", value: "status_i18n", width: "120px" },
		{ text: "製品番号", value: "product_number", width: "150px" },
		{ text: "製品名", value: "product_name", width: "200px" },
		{ text: "数量", value: "quantity", width: "80px" },
		{ text: "ホールディングポイント項目", value: "check_item.name", width: "300px" },
	]
}
</script>
